import { HealthProvider, IHealthProvider, HealthActivity, PermissionStatus } from '../types';
import logger from '../../../utils/logger';

/**
 * Base class for health providers
 */
export abstract class BaseHealthProvider implements IHealthProvider {
  abstract name: HealthProvider;
  
  abstract isAvailable(): Promise<boolean>;
  abstract requestPermissions(): Promise<PermissionStatus>;
  abstract checkPermissions(): Promise<PermissionStatus>;
  abstract saveActivity(activity: HealthActivity): Promise<boolean>;
  abstract getActivities(startDate: Date, endDate: Date): Promise<HealthActivity[]>;
  
  /**
   * Log health sync event
   */
  protected log(message: string, data?: any): void {
    logger.info(`[HealthSync:${this.name}] ${message}`, data);
  }
  
  /**
   * Log health sync error
   */
  protected logError(message: string, error?: any): void {
    logger.error(`[HealthSync:${this.name}] ${message}`, error);
  }
}